import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import Html from './html';
import shared from './shared';

function ContentManagement() {
  const [filters, setFilter] = useState({ page: 1, count: 10, search: '', platform: '' });
  const [allData, setAllData] = useState([]); // Store original data for client-side filtering
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const history = useNavigate();

  useEffect(() => {
    getData({ page: 1 });
  }, []);

  const getData = (p = {}) => {
    setLoading(true);
    loader(true);
    const filterParams = { ...filters, ...p };
    // Remove platform from API params as we filter on client side
    const { platform, ...apiParams } = filterParams;

    ApiClient.get(shared.listApi, apiParams).then((res) => {
      if (res.success) {
        console.log(res?.data, "Response is here ----")
        setAllData(res.data);
        applyClientFilter(res.data, filterParams.platform);
        setTotal(res.total);
      }
      loader(false);
      setLoading(false);
    });
  };

  const applyClientFilter = (fullList, platform) => {
    if (!platform) {
      setData(fullList);
    } else {
      const filtered = fullList.filter(itm => itm.platform?.toLowerCase() === platform.toLowerCase());
      setData(filtered);
    }
  };

  const clear = () => {
    const f = {
      search: '',
      page: 1,
      platform: '',
    };
    setFilter({ ...filters, ...f });
    getData({ ...f });
  };

  const filter = (p = {}) => {
    const newFilters = { ...filters, ...p };
    setFilter(newFilters);

    if (p.platform !== undefined) {
      // If it's a platform change, filter client-side
      applyClientFilter(allData, p.platform);
    } else {
      // If it's a search or page change, fetch from API
      getData(p);
    }
  };

  const pageChange = (e) => {
    setFilter({ ...filters, page: e });
    getData({ page: e });
  };

  const count = (e) => {
    setFilter({ ...filters, count: e });
    getData({ ...filters, count: e });
  };

  const edit = (id) => {
    history(`/${shared.route}/edit/${id}`);
  };
  const view = (id) => {
    history(`/${shared.route}/view/${id}`);
  };

  return (
    <Html
      edit={edit}
      view={view}
      clear={clear}
      count={count}
      pageChange={pageChange}
      filters={filters}
      setFilter={setFilter}
      filter={filter}
      loading={loading}
      data={data}
      total={total}
    />
  );
}

export default ContentManagement;
